<template lang="pug">
//- 业务模型-字段管理
.tableContainer(v-loading="loading", element-loading-text="数据读取中...")
  .operArea
    el-form(ref="form", :model="form", inline, size="small")
      el-form-item(label="业务模型编号：") {{ form.groupId }}
      el-form-item(label="业务模型名称：") {{ form.groupName }}
      el-form-item(label="备注：") {{ form.remark }}
    .right(v-if="!isRead")
      el-button(size="small", type="primary", plain, @click="copyModuleField") 快速添加字段
      el-button(size="small", @click="importExcel") 导入设置
      el-button(size="small", @click="refreshTable") 更新业务模型
      el-button(icon="el-icon-plus", size="small", @click="addTableData") 新增字段
      el-button(icon="el-icon-circle-plus-outline", size="small", @click="addFlowStatusFields") 新增流程状态字段
      el-button(type="primary", size="small", @click="saveTable") 保 存
  ul.tips
    li 请注意：
    li * 当数据类型是 numeric 时，内部长度和业务长度是指小数位数。实际长度是 18. 如设置长度为 6, 则为 numberic(18, 6)
  .dataMeta
    vxe-table(
      border,
      round,
      stripe,
      resizable,
      size="medium",
      show-overflow,
      keep-source,
      :row-class-name="headerRowClassName",
      ref="xTable",
      height="100%",
      :data="tableData",
      :edit-config="{ trigger: isRead ? 'manual' : 'click', mode: 'cell', activeMethod: activeRowMethod }"
    )
      vxe-column(type="seq", width="50", align="center", title="序号")
      vxe-column(field="columnName", align="center", title="内部名称", :edit-render="{}")
        template(#default="{ row }")
          span {{ row.columnName }}
        template(#edit="{ row, rowIndex }")
          vxe-input(
            v-model="row.columnName",
            v-if="row.isCustomField == 1 || row.curAttrName === ''",
            @blur="exitEdit(row)",
            type="text",
            size="medium",
            autofocus,
            :disabled="disableIdRow(rowIndex)"
          )
          span(v-else) {{ row.columnName }}
      vxe-column(field="columnDisplayName", align="center", title="显示名称", :edit-render="{ autofocus: '.vxe-input--inner' }")
        template(#edit="{ row }")
          vxe-input(v-model="row.columnDisplayName", type="text", size="medium")
      vxe-column(field="userTypeName", align="center", title="数据类型", :edit-render="{}")
        template(#default="{ row }")
          span {{ row.userTypeName }}
        template(#edit="{ row, rowIndex }")
          vxe-select(v-if="row.isCustomField === 0", v-model="row.userTypeName", transfer, size="medium", :disabled="disableIdRow(rowIndex)", @change="onDataTypeChange(row)")
            vxe-option(v-for="item in dataTypeList", :key="item.dicId", :value="item.cnName", :label="item.cnName")
          vxe-select(v-else, v-model="row.userTypeName", size="medium", transfer, :disabled="disableIdRow(rowIndex)", @change="onDataTypeChange(row)")
            vxe-option(v-for="item in notTableColumnDataType", :key="item.dicId", :value="item.cnName", :label="item.cnName")
      vxe-column(field="displayDataType", align="center", title="控件", :edit-render="{}")
        template(#default="{ row }")
          span {{ getContralName(row.displayDataType) }}
        template(#edit="{ row }")
          vxe-select(v-model="row.displayDataType", transfer, size="medium")
            vxe-option(v-for="item in controlList", :key="item.id", :value="item.enName", :label="item.cnName")
      vxe-column(field="isNullableBoolean", width="50", align="center", title="必填", v-slot="{ row, rowIndex }")
        vxe-checkbox(v-model="row.isNullableBoolean", :disabled="disableIdRow(rowIndex)")
      vxe-column(field="maxLength", align="center", width="60", title="内部长度", :edit-render="{}")
        template(#edit="{ row }")
          vxe-input(
            v-model="row.maxLength",
            type="number",
            v-if="canEditLength(row.userTypeName)",
            :min="rowMin(row.displayDataLength)",
            size="medium",
            @blur="checkMaxNumberLength(row)"
          )
          span(v-else) {{ row.maxLength }}
      vxe-column(field="displayDataLength", align="center", width="60", title="业务长度", :edit-render="{ name: 'eidtDataLength' }")
        template(#edit="{ row }")
          vxe-input(
            v-if="canEditLength(row.userTypeName)",
            v-model="row.displayDataLength",
            type="number",
            :max="rowMax(row.maxLength)",
            min="1",
            size="medium",
            @blur="checkDisplayNumberLength(row)"
          )
          span(v-else) {{ row.displayDataLength }}
      vxe-column(field="defaultValue", align="center", title="默认值", :edit-render="{}")
        template(#edit="{ row }")
          vxe-input(v-model="row.defaultValue", type="text", size="medium")
      vxe-column(field="isInternalField", align="center", title="内部字段", width="50", v-slot="{ row, rowIndex }")
        vxe-checkbox(v-model="row.isInternalFieldBoolean", :disabled="disableIdRow(rowIndex)")
      vxe-table-column(field="isCustomField", title="是否表字段", width="60", align="center", v-slot="{ row, rowIndex }")
        vxe-checkbox(v-model="row.isCustomField", size="small", @change="isCustomFieldChange(row)", :checked-value="0", :unchecked-value="1", :disabled="!!row.metaId")
      vxe-column(field="stdFieldType", align="center", title="标准型", :edit-render="{}")
        template(#default="{ row }")
          span {{ stdFieldTypeName(row.stdFieldType) }}
        template(#edit="{ row }")
          vxe-select(v-model="row.stdFieldType", transfer, size="medium")
            vxe-option(key="0", value=null, label="空")
            vxe-option(v-for="item in stdFieldTypeList", :key="item.stdFieldType", :value="item.stdFieldType", :label="item.stdFieldName")
      vxe-column(field="isUniqueKey", align="center", width="50", title="唯一约束")
        template(#default="{ row, rowIndex }")
          vxe-checkbox(v-model="row.isUniqueKey", size="small", :checked-value="1", :unchecked-value="0", :disabled="disableIdRow(rowIndex)")
      vxe-column(field="remark", align="center", title="备注", :edit-render="{}")
        template(#edit="{ row, rowIndex }")
          vxe-input(v-model="row.remark", type="text", size="medium", :disabled="disableIdRow(rowIndex)")
      vxe-column(field="slaveTableIdAndName", align="center", width="120px", title="绑定子表")
        template(#default="{ row, rowIndex }")
          span(v-if="row.slaveTableName", @click="relevance(row)", style="cursor: pointer; color: #6c92ec", title="关联") {{ row.slaveTableIdAndName }}
          el-button(type="text", v-else-if="hasRelevance(row, rowIndex)", @click="relevance(row)") 关联
      vxe-column(align="center", title="操作", width="90px")
        template(#default="{ row, rowIndex }")
          el-button(type="text", v-if="row.isCustomField == 1 && !disableIdRow(rowIndex)", @click="delCustomData(row)") 删除
  importExcelDialog(ref="importExcelDialog", :tableData="tableData", :tableName="form.groupId")
  el-dialog(v-dialogDrag, title="设置子表关联", :visible.sync="childFormDialog", width="400px", top="30vh", :before-close="handleClose")
    el-form(ref="childSetForm", :model="associationForm", label-width="110px", size="small", label-position="left", :rules="rules")
      el-form-item(label="字段")
        el-input(v-model="fielIdName", clearable, readonly, style="width: 260px")
      el-form-item(label="关联业务模型", prop="slaveTableName")
        el-select(v-model="associationForm.slaveTableName", @change="sublistChange", style="width: 260px")
          el-option(v-for="item in sublistOptions", :key="item.tableName", :label="item.businessName + '(' + item.tableName + ')'", :value="item.tableName")
      el-form-item(label="关联主表字段", prop="masterField", v-if="associationForm.slaveTableName")
        el-select(v-model="associationForm.masterField", style="width: 260px")
          el-option(
            v-for="item in tableData.filter((e) => e.isCustomField === 0)",
            :key="item.columnName",
            :value="item.columnName",
            :label="item.columnDisplayName + '(' + item.columnName + ')'"
          )
      el-form-item(label="关联子表字段", prop="slaveField", v-if="associationForm.slaveTableName")
        el-select(v-model="associationForm.slaveField", style="width: 260px")
          el-option(
            v-for="item in fieldsOptions.filter((e) => e.isCustomField === 0)",
            :key="item.columnName",
            :value="item.columnName",
            :label="item.columnDisplayName + '(' + item.columnName + ')'"
          )
      el-form-item(label="关联删除")
        el-checkbox(v-model="associationForm.isAssociateDelete") 允许关联删除
    div(slot="footer")
      el-button(@click="handleClose", size="small") 取 消
      el-button(type="primary", @click="onSubmit", size="small") 确 定
</template>

<script>
import "@/CommonDP/utils/vxe-table/index.js";
import { mapState } from "vuex";
import metadataService from "@/CommonDP/service/metadata-service.js";
import dicService from "@/CommonDP/service/dic-service.js";
import importExcelDialog from "./importExcelDialog.vue";
import { cloneDeep, isEqual } from "lodash-es";
import CopyModuleField from "../dialog/copyModuleField.vue";
import asyncCom from "@/CommonDP/commons/asyncCom";
const initForm = () => {
  return {
    slaveTableName: "", // 从表
    slaveField: "", // 从表字段
    isAssociateDelete: true, // 主从表关联删除 // 0 否  1:是
    masterTableName: "", // 主表
    masterField: "", // 主表字段
    relationType: 2 // 关联类型 1:1/1 ; 2:1/n
  };
};
export default {
  components: { importExcelDialog },
  props: {
    isRead: Boolean
  },
  data() {
    return {
      tableData: [],
      oldTableData: [],
      dataTypeList: [],
      notTableColumnDataType: [],
      controlList: [],
      stdFieldTypeList: [],
      displayDataTypeList: [],
      form: {
        groupId: "",
        groupName: "",
        remark: ""
      },
      currentPage: 1,
      loading: false,
      lockIdRow: false, // 锁定id那一列，不能编辑删除，修改时不传递
      childFormDialog: false,
      sublistOptions: [],
      fieldsOptions: [],
      associationRows: "", // 字段
      associationForm: initForm(),
      rules: {
        slaveTableName: [{ required: true, message: "关联业务模型不可为空", trigger: "change" }],
        masterField: [{ required: true, message: "主表字段不可为空", trigger: "change" }],
        slaveField: [{ required: true, message: "子表字段不可为空", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    fielIdName() {
      return this.associationRows.columnDisplayName + "(" + this.associationRows.columnName + ")";
    },
    // 数据是否和原数据一致
    isEqualOld() {
      return isEqual(this.tableData, this.oldTableData);
    }
  },
  mounted() {
    this.getControlDic();
    this.initDataTypeDict();
    this.initNotTableColumnDataTypeDict();
    this.queryDisplayDataTypeList();
    this.queryStdFieldTypeList();
    this.addEventListener();
  },

  methods: {
    async copyModuleField() {
      const list = await asyncCom(CopyModuleField, {}, { fieldKeys: this.tableData.map(({ columnName }) => columnName), tableId: this.form.groupId });
      const tem = this.newTableRow();
      const temKey = Object.keys(tem);
      const addList = list.map((row) => {
        const obj = {
          isNullableBoolean: row.isNullable === 0,
          isInternalFieldBoolean: row.isInternalField === 1,
          slaveTableIdAndName: row.slaveTableBusinessName ? row.slaveTableBusinessName + "(" + row.slaveTableName + ")" : row.slaveTableName
        };
        return temKey.reduce((obj, key) => {
          obj[key] ??= row[key] || tem[key];
          return obj;
        }, obj);
      });
      this.tableData.push(...addList);
    },
    // 添加浏览器事件,阻止页面关闭
    addEventListener() {
      const keyFn = (e) => {
        if (e.ctrlKey && e.code === "KeyS") {
          e.preventDefault();
          this.saveTable();
        }
      };
      const windowFn = (event) => {
        event.preventDefault();
        event.returnValue = "您当前有尚未保存的数据,确定离开";
      };
      document.addEventListener("keydown", keyFn);
      this.$watch("isEqualOld", (val) => {
        window.onbeforeunload = val ? null : windowFn;
      });
      this.$on("hook:beforeDestroy", () => {
        window.onbeforeunload = null;
        document.removeEventListener("keydown", keyFn);
      });
    },
    async getcolumnList(data) {
      this.loading = true;
      this.initMetaDetail(data);
      const res = await metadataService.columnList(data.groupId);
      this.form = { ...data };
      const array = res.data || [];
      array.forEach((element) => {
        element.isNullableBoolean = element.isNullable === 0;
        element.isInternalFieldBoolean = element.isInternalField === 1;
        element.slaveTableIdAndName = element.slaveTableBusinessName ? element.slaveTableBusinessName + "(" + element.slaveTableName + ")" : element.slaveTableName;
      });
      this.tableData = array;
      this.loading = false;
      // 保存旧数据,vex组件在初始化数据会导致数据修改,所以添加nextTick等待
      this.$nextTick().then(() => {
        this.oldTableData = cloneDeep(array);
      });
    },
    async initMetaDetail(data) {
      const res = await metadataService.dynMetaDetailByGroupId(data.groupId);
      this.lockIdRow = res.data.isDynamic === 1;
    },
    // 导入设置
    importExcel() {
      this.$refs.importExcelDialog.openDialog();
    },
    isCustomFieldChange(row) {
      if (row.isCustomField === 0) {
        row.userTypeName = "varchar";
      } else {
        row.userTypeName = "list";
      }
    },
    disableIdRow(rowIndex) {
      return this.isRead || (this.lockIdRow && rowIndex === 0);
    },
    onEdit(row, attrName) {
      if (row.isCustomField === 1) this.$set(row, "curAttrName", attrName);
    },
    exitEdit(e, row) {
      if (typeof e === "boolean") {
        if (row.isCustomField === 1 && !e) row.curAttrName = "";
      } else {
        row = e;
        if (row.isCustomField === 1) row.curAttrName = "";
      }
    },
    async onDataTypeChange(row) {
      if (row.userTypeName === "numeric") {
        this.$set(row, "maxLength", 2);
        this.$set(row, "displayDataLength", 2);
      }
      let displayDataType;
      const key = row.userTypeName;
      switch (key) {
        case "date":
          displayDataType = "date";
          break;
        case "datetime":
          displayDataType = "time";
          break;
        case "int":
        case "tinyint":
          displayDataType = "number";
          break;
        default:
          displayDataType = "input";
          break;
      }
      this.$set(row, "displayDataType", displayDataType);
    },
    async checkMaxNumberLength(row) {
      this.checkNumberLength(row, "maxLength");
    },
    async checkDisplayNumberLength(row) {
      this.checkNumberLength(row, "displayLength");
    },
    async checkNumberLength(row, fieldName) {
      // 不做任何操作
    },
    newTableRow() {
      return {
        isCustomField: 0,
        curAttrName: "",
        isAdd: true,
        columnDesc: ``,
        columnDisplayName: "新建字段",
        columnName: `column${Math.floor(Math.random() * 1000)}`,
        displayDataType: "input",
        defaultValue: "",
        displayDataLength: 32,
        isUniqueKey: 0,
        isInternalField: 0,
        isInternalFieldBoolean: false,
        isNullable: 0,
        maxLength: 32,
        stdFieldType: "",
        tableName: this.tableData[0].tableName,
        userTypeName: "varchar",
        hasNoSave: true
      };
    },
    // 新增字段
    addTableData() {
      const target = this.newTableRow();
      this.tableData.push(target);
      const $table = this.$refs.xTable;
      $table.setActiveRow(target);
    },
    addFlowStatusFields() {
      const exists = this.tableData.some((row) => row.columnName === "flowStatus");
      if (exists) {
        this.$error("已经存在名为 flowStatus 的字段");
        return;
      }
      const flowStatusRow = {
        isCustomField: 0,
        curAttrName: "",
        isAdd: true,
        columnDesc: ``,
        columnDisplayName: "审批状态值",
        columnName: `flowStatus`,
        displayDataType: "input",
        defaultValue: "",
        displayDataLength: 32,
        isUniqueKey: 0,
        isInternalField: 1,
        isInternalFieldBoolean: true,
        isNullable: 0,
        maxLength: 32,
        stdFieldType: "flowStatus",
        tableName: this.tableData[0].tableName,
        userTypeName: "varchar"
      };
      this.tableData.push(flowStatusRow);
      const flowStatusNameRow = {
        isCustomField: 0,
        curAttrName: "",
        isAdd: true,
        columnDesc: ``,
        columnDisplayName: "审批状态",
        columnName: `flowStatusName`,
        displayDataType: "input",
        defaultValue: "",
        displayDataLength: 32,
        isUniqueKey: 0,
        isInternalField: 1,
        isInternalFieldBoolean: true,
        isNullable: 0,
        maxLength: 32,
        stdFieldType: "flowStatusName",
        tableName: this.tableData[0].tableName,
        userTypeName: "varchar"
      };
      this.tableData.push(flowStatusNameRow);
    },
    // 关联
    async relevance(row) {
      this.associationRows = row;
      const { columnName, columnDisplayName, hasNoSave = false } = row;
      if (hasNoSave) {
        this.$warn("该字段未保存，请先保存再关联");
        return;
      }
      this.associationForm.fields = columnDisplayName + "(" + columnName + ")";
      await this.queryMasterSlaveRelation();
      await this.queryDynMetaListByGroupID();
      this.childFormDialog = true;
    },
    // 查询同级业务模型
    async queryDynMetaListByGroupID() {
      const res = await metadataService.queryDynMetaListByGroupID(this.form.parentId);
      this.sublistOptions = res.data
        .filter((e) => e.tableName !== this.form.groupId)
        .map((item) => {
          item.tableNameLower = item.tableName?.toLocaleLowerCase();
          item.tableDescLower = item.tableDesc?.toLocaleLowerCase();
          item.keyFieldNames = item.tableNameLower + item.tableDescLower;
          return item;
        });
    },
    // 子表下拉框change事件
    async sublistChange(val) {
      await this.queryMasterSlaveRelation(val);
      await this.getAssociatedField(slaveTableName);
    },
    // 查看主从表是否关联
    async queryMasterSlaveRelation(slaveTableName = "") {
      const { columnName, tableName } = this.associationRows;
      const params = {
        masterTableName: tableName,
        slaveTableName,
        fieldKey: columnName
      };
      const res = await metadataService.queryMasterSlaveRelation(params);
      if (res.data) {
        this.associationForm.isAssociateDelete = res.data?.isAssociateDelete === 1;
        this.associationForm.masterField = res.data?.masterField || "";
        this.associationForm.masterTableName = res.data?.masterTableName || "";
        this.associationForm.relationType = res.data?.relationType || 2;
        this.associationForm.slaveField = res.data?.slaveField || "";
        this.associationForm.slaveTableName = res.data?.slaveTableName || "";
      } else {
        this.associationForm = initForm();
        this.associationForm.slaveTableName = slaveTableName;
      }
      if (this.associationForm.slaveTableName) {
        this.getAssociatedField(this.associationForm.slaveTableName);
      }
    },
    // 查询子表的字段
    async getAssociatedField(slaveTableName) {
      const { data } = await metadataService.columnList(slaveTableName);
      this.fieldsOptions = data || [];
    },
    // 确定关联
    async onSubmit() {
      await this.$refs.childSetForm.validate();
      const { slaveTableName, slaveField, relationType, isAssociateDelete } = this.associationForm;
      const { columnName, tableName } = this.associationRows;
      const masterField = this.tableData.filter((e) => e.isPrimaryKey === 1)[0].columnName;
      const params = {
        masterTableName: tableName, // 主表名称
        slaveTableName, // 子表名称
        slaveField, // 在子表中，与主表 id 关联的字段
        masterField, // 主表的字段名称，一般是主表的主键
        relationType, // 关系
        isAssociateDelete: isAssociateDelete ? 1 : 0, // 0 否  1:是 允许关联删除
        fieldKey: columnName // 从表存储字段的key
      };
      try {
        await metadataService.saveSlaveTableField(params);
        this.$success("关联成功!");
        this.getcolumnList(this.form);
      } catch (error) {
        console.log(error);
      }
      this.childFormDialog = false;
    },
    handleClose() {
      this.childFormDialog = false;
    },
    // 删除
    async delCustomData(row) {
      await this.$confirm(`您将删除当前字段，此操作无法撤销，继续操作吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (row.isAdd) {
        const index = this.tableData.indexOf(row);
        this.tableData.splice(index, 1);
      } else {
        metadataService.deleteNotTableField(row.metaId).then((res) => {
          if (res.result === "0") {
            this.$success("删除成功!");
            this.getcolumnList(this.form);
          }
        });
      }
    },

    async addCustomData(row) {
      await this.$confirm(`确认保存当前设置的数据吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      metadataService.addNotTableField(row).then((res) => {
        if (res.result === "0") {
          this.$success("新增成功!");
          this.getcolumnList(this.form);
        }
      });
    },
    async initDataTypeDict() {
      const res = await dicService.getDicList("DataType");
      this.dataTypeList = res.data || [];
    },
    async initNotTableColumnDataTypeDict() {
      const res = await dicService.getDicList("COLUMNDATATYPE");
      this.notTableColumnDataType = res.data || [];
    },
    getUserTypeName(cnName) {
      return this.dataTypeList.find((e) => e.cnName === cnName)?.cnName || cnName;
    },
    getNotTableColumnDataTypeName(cnName) {
      return this.notTableColumnDataType.find((e) => e.cnName === cnName)?.cnName || cnName;
    },
    relationList(row) {
      return this.tableData
        .filter((e) => e.columnName !== row.columnName)
        .map((item) => {
          const obj = {
            columnName: `${item.columnDisplayName}(${item.columnName})`,
            id: item.id
          };
          return obj;
        });
    },
    rowMax(length) {
      return length > 0 ? length : null;
    },
    rowMin(length) {
      return length > 0 ? length : 1;
    },

    async getControlDic() {
      const res = await dicService.queryDicContentByName("CONTROL");
      this.controlList = res.data || [];
    },
    async queryStdFieldTypeList() {
      const res = await metadataService.queryStdFieldTypeList();
      this.stdFieldTypeList = res.data || [];
    },
    async queryDisplayDataTypeList() {
      const res = await metadataService.queryStdFieldTypeList();
      this.displayDataTypeList = res.data || [];
    },
    // 重置
    initTable() {
      const $table = this.$refs.xTable;
      $table.revertData();
    },
    async refreshTable() {
      await this.$confirm(`请注意，当前未保存的内容将丢失，继续更新吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.loading = true;
      await metadataService.updateMeta([this.form.groupId]);
      this.getcolumnList(this.form);
    },
    activeRowMethod({ row, rowIndex, column, columnIndex }) {
      if (this.lockIdRow && rowIndex === 0) {
        return false;
      }
      return true;
    },
    // 保存
    async saveTable() {
      await this.$confirm(`确认保存当前设置的数据吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.tableData.forEach((row) => {
        row.isNullable = row.isNullableBoolean ? 0 : 1;
        row.isInternalField = row.isInternalFieldBoolean ? 1 : 0;
      });
      const table = [...this.tableData];
      const columnList = table;
      const params = {
        tableName: this.form.groupId,
        columnList
      };
      await metadataService.saveTable(params);
      this.$success("保存成功!");
      this.getcolumnList(this.form);
    },
    getContralName(enName) {
      return this.controlList.find((e) => e.enName === enName)?.cnName;
    },
    stdFieldTypeName(stdFieldType) {
      return this.stdFieldTypeList.find((e) => e.stdFieldType === stdFieldType)?.stdFieldName;
    },
    displayDataTypeName(stdFieldType) {
      return this.stdFieldTypeList.find((e) => e.stdFieldType === stdFieldType)?.stdFieldName;
    },
    headerRowClassName({ row }) {
      if (row.isCustomField === 1) return "blue";
      return "";
    },
    hasRelevance(row, rowIndex) {
      return row.isCustomField === 1 && row.userTypeName === "list" && row.displayDataType === "subTable" && !this.disableIdRow(rowIndex);
    },
    canEditLength(userTypeName) {
      return ["varchar", "nvarchar", "char", "nchar", "numeric"].includes(userTypeName);
    }
  }
};
</script>

<style lang="scss" scoped>
.tableContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cellStyle {
  min-width: 50px;
  min-height: 20px;
}

/deep/ .blue {
  background-color: #e9f4ff !important;
}

.operArea {
  height: 40px;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  /deep/.el-form-item {
    margin-bottom: 0px;
  }

  // /deep/.el-form-item__label {
  //   padding-right: 5px;
  // }

  .right {
    margin-left: auto;
  }
}

.dataMeta {
  flex: 1 1;
  overflow-y: auto;
}

.page {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

/deep/.vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default.vxe-editable .vxe-body--column.col--actived {
  box-sizing: border-box;
  padding: 11px 0;
}

.tips {
  color: darkgray;
  height: 40px;
  font-size: 12px;
  padding: 0 10px;
  // margin-bottom: 5px;
}
</style>
